import {
  SandboxClient,
  type SandboxClientOptions,
} from "@imagine/sandbox-instrumentation/client";
import { lens } from "@dhmk/zustand-lens";

type SandboxStateState = {
  sandboxClient: SandboxClient | null;
  instrumented: boolean;
};

type SandboxStateActions = {
  createSandboxClient: (options: SandboxClientOptions) => void;
  setSandboxClient: (client: SandboxClient | null) => void;
  setInstrumented: (value: boolean) => void;
  reset: () => void;
};

export type SandboxStateSlice = SandboxStateState & SandboxStateActions;

const defaultSandboxState = {
  sandboxClient: null,
  instrumented: false,
};

export const sandboxStateSlice = lens<SandboxStateSlice>((set, get, api) => ({
  ...defaultSandboxState,
  createSandboxClient: (options: SandboxClientOptions) => {
    const client = new SandboxClient(options);
    set({ sandboxClient: client });
  },
  setSandboxClient: (client) => set({ sandboxClient: client }),
  instrumented: false,
  setInstrumented: (value) => set({ instrumented: value }),
  reset: () => set({ ...defaultSandboxState }),
}));
